import home from "../assets/icons/home.svg";
import report from "../assets/icons/report.svg";
import user from "../assets/icons/user.svg";
export const iconsImgs = {
  home,
  report,
  user,
};